export default "__VITE_ASSET__C1LeH3gT__"